import { render, staticRenderFns } from "./CourseCoupon.vue?vue&type=template&id=a4ecd93e&scoped=true"
import script from "./CourseCoupon.vue?vue&type=script&lang=js"
export * from "./CourseCoupon.vue?vue&type=script&lang=js"
import style0 from "./CourseCoupon.vue?vue&type=style&index=0&id=a4ecd93e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ecd93e",
  null
  
)

export default component.exports